var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigbusiness4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 251,
    viewBox: "0 0 250 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_6762)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.125,
    width: 250,
    height: 250,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 17.9658,
    y1: 119.593,
    x2: 17.9658,
    y2: -21.9222,
    stroke: "url(#paint0_linear_75_6762)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.9658,
    y1: 119.593,
    x2: 52.9658,
    y2: -21.9222,
    stroke: "url(#paint1_linear_75_6762)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.9658,
    y1: 119.593,
    x2: 88.9658,
    y2: -21.9222,
    stroke: "url(#paint2_linear_75_6762)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.966,
    y1: 119.593,
    x2: 124.966,
    y2: -21.9222,
    stroke: "url(#paint3_linear_75_6762)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.966,
    y1: 119.593,
    x2: 160.966,
    y2: -21.9222,
    stroke: "url(#paint4_linear_75_6762)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.966,
    y1: 119.593,
    x2: 195.966,
    y2: -21.9222,
    stroke: "url(#paint5_linear_75_6762)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.966,
    y1: 119.593,
    x2: 231.966,
    y2: -21.9223,
    stroke: "url(#paint6_linear_75_6762)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 18.4539,
    x2: 258.387,
    y2: 18.4538,
    stroke: "url(#paint7_linear_75_6762)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 77.4539,
    x2: 258.387,
    y2: 77.4538,
    stroke: "url(#paint8_linear_75_6762)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 47.4539,
    x2: 258.387,
    y2: 47.4538,
    stroke: "url(#paint9_linear_75_6762)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 16.625,
    width: 87,
    height: 87,
    rx: 43.5,
    fill: "url(#paint10_linear_75_6762)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5762 41.9162C64.8324 42.0589 65.0335 42.2832 65.1474 42.5534C65.2612 42.8237 65.2813 43.1243 65.2044 43.4072L61.7184 56.1875H74.4374C74.6932 56.1875 74.9434 56.2623 75.1573 56.4026C75.3711 56.5429 75.5394 56.7426 75.6412 56.9772C75.7431 57.2118 75.7742 57.4711 75.7307 57.7232C75.6872 57.9752 75.571 58.2091 75.3964 58.396L57.0214 78.0835C56.8213 78.2984 56.5549 78.44 56.2648 78.4856C55.9747 78.5312 55.6777 78.4782 55.4212 78.335C55.1648 78.1919 54.9638 77.9669 54.8504 77.6961C54.7369 77.4252 54.7176 77.1241 54.7954 76.841L58.2814 64.0625H45.5624C45.3066 64.0625 45.0564 63.9877 44.8426 63.8474C44.6287 63.7071 44.4605 63.5074 44.3586 63.2728C44.2567 63.0382 44.2256 62.7789 44.2691 62.5268C44.3126 62.2748 44.4288 62.0409 44.6034 61.854L62.9784 42.1665C63.1786 41.9524 63.4446 41.8114 63.7342 41.7661C64.0237 41.7207 64.3201 41.7736 64.5762 41.9162Z",
    fill: "#83A735"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 16.625,
    width: 87,
    height: 87,
    rx: 43.5,
    stroke: "url(#paint11_linear_75_6762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3889 185.348C27.8088 185.348 29.6616 183.25 29.6616 180.973C29.6616 178.785 28.1883 177.424 25.1971 176.888L21.5584 176.263C19.7949 175.883 19.0359 175.459 19.0359 174.164C19.0359 172.825 20.1074 172.155 22.8308 172.155C25.9337 172.155 27.0275 173.071 27.0275 174.901V175.191H29.4161V175.057C29.4161 172.133 27.4293 169.945 23.0541 169.945C18.4109 169.945 16.625 172.133 16.625 174.298C16.625 176.754 18.4109 177.915 20.9334 178.361L24.5943 178.964C26.4918 179.321 27.2508 179.812 27.2508 181.107C27.2508 182.513 26.2462 183.138 23.3889 183.138C20.1074 183.138 19.0582 182.245 19.0582 180.46V180.102H16.6474V180.236C16.6474 183.384 18.9243 185.348 23.3889 185.348ZM33.7841 185.125V179.634C33.7841 177.178 34.61 175.973 36.9986 175.973C39.1416 175.973 39.9898 176.91 39.9898 179.098V185.125H42.3784V179.634C42.3784 177.178 43.2267 175.973 45.5929 175.973C47.7359 175.973 48.6065 176.91 48.6065 179.098V185.125H50.9951V178.45C50.9951 175.772 49.5441 173.807 46.6644 173.807C43.8517 173.807 42.6016 175.571 42.3114 177.468H42.1775C41.865 175.348 40.5033 173.807 37.9808 173.807C35.2127 173.807 34.0073 175.526 33.7171 177.379H33.5832V174.03H31.3732V185.125H33.7841ZM58.8212 185.348C62.5268 185.348 65.0046 183.004 65.0046 179.589C65.0046 176.129 62.5268 173.807 58.8212 173.807C55.1379 173.807 52.66 176.129 52.66 179.589C52.66 183.004 55.1379 185.348 58.8212 185.348ZM58.8212 183.205C56.1424 183.205 55.0263 181.933 55.0263 179.589C55.0263 177.223 56.1424 175.928 58.8212 175.928C61.5222 175.928 62.6384 177.223 62.6384 179.589C62.6384 181.933 61.5222 183.205 58.8212 183.205ZM72.4242 185.348C76.1298 185.348 78.6077 183.004 78.6077 179.589C78.6077 176.129 76.1298 173.807 72.4242 173.807C68.7409 173.807 66.2631 176.129 66.2631 179.589C66.2631 183.004 68.7409 185.348 72.4242 185.348ZM72.4242 183.205C69.7455 183.205 68.6293 181.933 68.6293 179.589C68.6293 177.223 69.7455 175.928 72.4242 175.928C75.1253 175.928 76.2414 177.223 76.2414 179.589C76.2414 181.933 75.1253 183.205 72.4242 183.205ZM87.6345 185.125V182.96H85.6254C84.2414 182.96 83.6164 182.603 83.6164 181.241V176.04H87.6345V174.03H83.6164V171.597H81.2278V174.03H79.3527V176.04H81.2278V181.375C81.2278 184.076 82.7011 185.125 85.0897 185.125H87.6345ZM91.5534 185.125V179.745C91.5534 177.401 92.491 175.973 95.1251 175.973C97.4243 175.973 98.4289 176.866 98.4289 179.098V185.125H100.817V178.517C100.817 175.816 99.3218 173.807 96.2636 173.807C93.4285 173.807 92.0668 175.548 91.6873 177.424H91.5534V170.169H89.1425V185.125H91.5534ZM114.078 185.125V182.96H112.069C110.685 182.96 110.059 182.603 110.059 181.241V176.04H114.078V174.03H110.059V171.597H107.671V174.03H105.796V176.04H107.671V181.375C107.671 184.076 109.144 185.125 111.533 185.125H114.078ZM117.997 185.125V178.897C117.997 176.91 118.778 175.861 120.675 175.861C122.327 175.861 122.997 176.598 122.997 178.183V179.165H125.385V177.714C125.385 175.615 124.292 173.807 121.769 173.807C119.492 173.807 118.287 175.236 117.952 177.022H117.796V174.03H115.586V185.125H117.997ZM130.159 185.348C132.681 185.348 134.445 184.232 135.025 182.357H135.182V185.125H137.391V178.383C137.391 175.727 135.807 173.807 132.28 173.807C128.753 173.807 126.654 175.705 126.654 178.227V178.317H129.043V178.227C129.043 176.598 130.047 175.928 132.101 175.928C134.222 175.928 135.025 176.575 135.025 178.406V179.053L129.98 179.589C127.793 179.834 126.409 180.727 126.409 182.446C126.409 184.277 127.86 185.348 130.159 185.348ZM128.819 182.29C128.819 181.419 129.422 181.129 130.672 180.973L135.025 180.482C135.025 182.669 133.329 183.607 130.806 183.607C129.422 183.607 128.819 183.183 128.819 182.29ZM141.954 185.125V179.634C141.954 177.223 143.048 175.973 145.481 175.973C147.781 175.973 148.718 177.022 148.718 179.098V185.125H151.129V178.45C151.129 175.883 149.611 173.807 146.531 173.807C143.718 173.807 142.245 175.593 141.91 177.468H141.754V174.03H139.544V185.125H141.954ZM158.523 185.348C161.649 185.348 163.702 184.12 163.702 182.044C163.702 180.214 162.497 179.321 159.863 178.986L157.296 178.629C155.621 178.406 155.175 178.093 155.175 177.223C155.175 176.173 155.889 175.727 157.921 175.727C160.376 175.727 161.046 176.419 161.046 177.736V177.87H163.434V177.803C163.434 175.169 161.381 173.807 157.988 173.807C154.572 173.807 152.809 175.191 152.809 177.133C152.809 178.986 154.081 179.879 156.179 180.147L159.215 180.549C160.8 180.772 161.336 181.062 161.336 181.977C161.336 182.96 160.689 183.406 158.523 183.406C156.202 183.406 155.331 182.937 155.331 181.486V181.308H152.92V181.375C152.92 183.942 154.952 185.348 158.523 185.348ZM168.701 185.348C171.223 185.348 172.987 184.232 173.567 182.357H173.723V185.125H175.933V178.383C175.933 175.727 174.349 173.807 170.821 173.807C167.294 173.807 165.196 175.705 165.196 178.227V178.317H167.585V178.227C167.585 176.598 168.589 175.928 170.643 175.928C172.764 175.928 173.567 176.575 173.567 178.406V179.053L168.522 179.589C166.335 179.834 164.951 180.727 164.951 182.446C164.951 184.277 166.402 185.348 168.701 185.348ZM167.361 182.29C167.361 181.419 167.964 181.129 169.214 180.973L173.567 180.482C173.567 182.669 171.871 183.607 169.348 183.607C167.964 183.607 167.361 183.183 167.361 182.29ZM183.689 185.348C187.015 185.348 189.448 183.473 189.448 180.705V180.46H187.059V180.616C187.059 182.335 185.809 183.183 183.644 183.183C181.144 183.183 180.028 181.977 180.028 179.589C180.028 177.156 181.144 175.973 183.644 175.973C185.809 175.973 187.059 176.821 187.059 178.54V178.674H189.448V178.45C189.448 175.682 187.015 173.807 183.689 173.807C180.028 173.807 177.639 176.129 177.639 179.589C177.639 183.004 180.028 185.348 183.689 185.348ZM198.508 185.125V182.96H196.499C195.115 182.96 194.49 182.603 194.49 181.241V176.04H198.508V174.03H194.49V171.597H192.101V174.03H190.226V176.04H192.101V181.375C192.101 184.076 193.575 185.125 195.963 185.125H198.508ZM202.427 172.736V170.169H200.016V172.736H202.427ZM202.427 185.125V174.03H200.016V185.125H202.427ZM210.329 185.348C214.035 185.348 216.513 183.004 216.513 179.589C216.513 176.129 214.035 173.807 210.329 173.807C206.646 173.807 204.168 176.129 204.168 179.589C204.168 183.004 206.646 185.348 210.329 185.348ZM210.329 183.205C207.651 183.205 206.535 181.933 206.535 179.589C206.535 177.223 207.651 175.928 210.329 175.928C213.031 175.928 214.147 177.223 214.147 179.589C214.147 181.933 213.031 183.205 210.329 183.205ZM220.673 185.125V179.634C220.673 177.223 221.767 175.973 224.2 175.973C226.5 175.973 227.437 177.022 227.437 179.098V185.125H229.848V178.45C229.848 175.883 228.33 173.807 225.25 173.807C222.437 173.807 220.964 175.593 220.629 177.468H220.472V174.03H218.262V185.125H220.673ZM22.6969 212.348C26.0007 212.348 28.3223 210.719 28.3223 208.352V208.152H25.9114V208.33C25.9114 209.647 24.9515 210.406 22.6299 210.406C20.0628 210.406 19.0136 209.268 18.9243 207.125H28.3446C28.4116 206.79 28.4339 206.477 28.4339 206.075C28.4339 202.705 26.09 200.807 22.6522 200.807C19.0359 200.807 16.6697 203.129 16.6697 206.589C16.6697 210.295 19.0582 212.348 22.6969 212.348ZM22.6076 202.705C24.9738 202.705 26.1569 203.687 26.1569 205.741V205.785H18.9466C19.0806 203.799 20.1521 202.705 22.6076 202.705ZM32.0701 212.125L35.7087 207.884H35.865L39.5483 212.125H42.4726L37.6955 206.589V206.455L42.4726 201.03H39.5706L35.932 205.227H35.798L32.1147 201.03H29.1904L33.9675 206.5V206.634L29.1904 212.125H32.0701ZM46.0573 215.92V209H46.1466C46.5931 211.031 48.2003 212.348 50.7005 212.348C54.1606 212.348 56.058 210.027 56.058 206.589C56.058 203.151 54.1159 200.807 50.6782 200.807C48.0664 200.807 46.5038 202.057 46.0573 204.111H45.8564V201.03H43.6464V215.92H46.0573ZM46.0573 206.767V206.567C46.0573 204.178 47.4413 203.017 49.9192 203.017C52.2408 203.017 53.6471 203.91 53.6471 206.589C53.6471 209.245 52.2631 210.161 49.8746 210.161C47.5083 210.161 46.0573 209.044 46.0573 206.767ZM63.3098 212.348C66.6136 212.348 68.9352 210.719 68.9352 208.352V208.152H66.5243V208.33C66.5243 209.647 65.5644 210.406 63.2429 210.406C60.6757 210.406 59.6265 209.268 59.5372 207.125H68.9575C69.0245 206.79 69.0468 206.477 69.0468 206.075C69.0468 202.705 66.7029 200.807 63.2652 200.807C59.6489 200.807 57.2826 203.129 57.2826 206.589C57.2826 210.295 59.6712 212.348 63.3098 212.348ZM63.2205 202.705C65.5868 202.705 66.7699 203.687 66.7699 205.741V205.785H59.5596C59.6935 203.799 60.765 202.705 63.2205 202.705ZM73.2634 212.125V205.897C73.2634 203.91 74.0447 202.861 75.9422 202.861C77.5941 202.861 78.2638 203.598 78.2638 205.183V206.165H80.6523V204.714C80.6523 202.615 79.5585 200.807 77.036 200.807C74.7591 200.807 73.5536 202.236 73.2188 204.022H73.0625V201.03H70.8525V212.125H73.2634ZM84.5775 199.736V197.169H82.1666V199.736H84.5775ZM84.5775 212.125V201.03H82.1666V212.125H84.5775ZM92.3907 212.348C95.6945 212.348 98.0161 210.719 98.0161 208.352V208.152H95.6052V208.33C95.6052 209.647 94.6453 210.406 92.3237 210.406C89.7566 210.406 88.7074 209.268 88.6181 207.125H98.0384C98.1054 206.79 98.1277 206.477 98.1277 206.075C98.1277 202.705 95.7838 200.807 92.346 200.807C88.7297 200.807 86.3635 203.129 86.3635 206.589C86.3635 210.295 88.7521 212.348 92.3907 212.348ZM92.3014 202.705C94.6676 202.705 95.8508 203.687 95.8508 205.741V205.785H88.6404C88.7744 203.799 89.8459 202.705 92.3014 202.705ZM102.344 212.125V206.634C102.344 204.223 103.438 202.973 105.871 202.973C108.171 202.973 109.108 204.022 109.108 206.098V212.125H111.519V205.45C111.519 202.883 110.001 200.807 106.92 200.807C104.108 200.807 102.634 202.593 102.3 204.468H102.143V201.03H99.9334V212.125H102.344ZM119.27 212.348C122.596 212.348 125.03 210.473 125.03 207.705V207.46H122.641V207.616C122.641 209.335 121.391 210.183 119.226 210.183C116.725 210.183 115.609 208.977 115.609 206.589C115.609 204.156 116.725 202.973 119.226 202.973C121.391 202.973 122.641 203.821 122.641 205.54V205.674H125.03V205.45C125.03 202.682 122.596 200.807 119.27 200.807C115.609 200.807 113.221 203.129 113.221 206.589C113.221 210.004 115.609 212.348 119.27 212.348ZM132.393 212.348C135.697 212.348 138.019 210.719 138.019 208.352V208.152H135.608V208.33C135.608 209.647 134.648 210.406 132.326 210.406C129.759 210.406 128.71 209.268 128.621 207.125H138.041C138.108 206.79 138.13 206.477 138.13 206.075C138.13 202.705 135.786 200.807 132.349 200.807C128.732 200.807 126.366 203.129 126.366 206.589C126.366 210.295 128.755 212.348 132.393 212.348ZM132.304 202.705C134.67 202.705 135.853 203.687 135.853 205.741V205.785H128.643C128.777 203.799 129.848 202.705 132.304 202.705Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_6762",
    x1: 19.4661,
    y1: 182.688,
    x2: 19.4661,
    y2: 48.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_75_6762",
    x1: 54.4661,
    y1: 182.688,
    x2: 54.4661,
    y2: 48.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_75_6762",
    x1: 90.4661,
    y1: 182.688,
    x2: 90.4661,
    y2: 48.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_75_6762",
    x1: 126.466,
    y1: 182.688,
    x2: 126.466,
    y2: 48.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_75_6762",
    x1: 162.466,
    y1: 182.688,
    x2: 162.466,
    y2: 48.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_75_6762",
    x1: 197.466,
    y1: 182.688,
    x2: 197.466,
    y2: 48.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_75_6762",
    x1: 233.466,
    y1: 182.688,
    x2: 233.466,
    y2: 48.8352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_75_6762",
    x1: 269.17,
    y1: 18.9539,
    x2: -9.24119,
    y2: 18.9541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#E8FDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#E8FDBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_75_6762",
    x1: 269.17,
    y1: 77.9539,
    x2: -9.24119,
    y2: 77.9541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#E8FDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#E8FDBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_75_6762",
    x1: 269.17,
    y1: 47.9539,
    x2: -9.24119,
    y2: 47.9541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#E8FDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#E8FDBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_75_6762",
    x1: 60,
    y1: 16.125,
    x2: 62.6601,
    y2: 133.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3FEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508459,
    stopColor: "#E8FDBE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_75_6762",
    x1: 60,
    y1: 16.125,
    x2: 60,
    y2: 104.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDFCA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8FDBE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_6762"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.125,
    width: 250,
    height: 250,
    rx: 10,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigbusiness4);
export default __webpack_public_path__ + "static/media/bigbusiness4.4faa0d0491a1f9f84ef8607064e4046b.svg";
export { ForwardRef as ReactComponent };